<script>
import { mapState } from 'vuex'
import { readableDate, readableFilesize } from '../../../helpers'
import noData from '../../common/table/no-data'

export default {
  components: {
    noData
  },
  props: {
    view: {
      type: String,
      required: true
    },
    rowClickEnabled: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      // -- define in table --
      // formFields: [],
      // namespace: null,
      // routeParamName: null,
      // rowClickRoute: null,

      searchDelay: 750,
      searchTimeout: null
    }
  },
  computed: {
    ...mapState('client', {
      client: 'data'
    }),
    views () {
      return this.$store.state[this.namespace].views
    },
    data () {
      return this.$store.getters[`${this.namespace}/view`](this.view)
    },
    noData () {
      return !this.data.length && !this.fetching
    },
    meta () {
      return this.views[this.view].meta
    },
    fetching () {
      return this.views[this.view].fetching
    }
  },
  watch: {
    fetching (newValue, oldValue) {
      if (newValue === false && oldValue === true) {
        this.$nextTick(() => this.$refs.search.$el.focus())
      }
    }
  },
  mounted () {
    this.onMount()
  },
  methods: {
    readableDate,
    readableFilesize,
    onMount () {
      this.$store.commit(`${this.namespace}/setMetaProp`, {
        view: this.view,
        prop: 'search',
        value: null
      })
      this.$store.commit(`${this.namespace}/setMetaProp`, {
        view: this.view,
        prop: 'current_page',
        value: 1
      })
      this.fetch()
    },
    rowClicked (item) {
      if (this.rowClickEnabled) {
        this.$router.push({
          name: this.rowClickRoute,
          params: {
            [this.routeParamName]: item.id
          }
        })
      }
    },
    fetch () {
      this.$store.dispatch(`${this.namespace}/index`, this.view)
    },
    search (event) {
      if (event.key === 'Enter') {
        this.fetch()
      }
    },
    searchChanged (value) {
      this.$store.commit(`${this.namespace}/setMetaProp`, {
        view: this.view,
        prop: 'search',
        value
      })
      this.$store.commit(`${this.namespace}/setMetaProp`, {
        view: this.view,
        prop: 'current_page',
        value: 1
      })
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        if (!this.fetching) {
          this.fetch()
        }
      }, this.searchDelay)
    },
    sortChanged (event) {
      this.$store.commit(`${this.namespace}/setMetaProp`, {
        view: this.view,
        prop: 'order',
        value: event.sortBy
      })
      this.$store.commit(`${this.namespace}/setMetaProp`, {
        view: this.view,
        prop: 'desc',
        value: event.sortDesc
      })
      this.fetch()
    },
    pageChanged (page) {
      this.$store.commit(`${this.namespace}/setMetaProp`, {
        view: this.view,
        prop: 'current_page',
        value: page
      })
      this.fetch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/mixins/table.vue